export default __webpack_public_path__ + "static/media/brand-icon.25a6f90b.png";